import { createSlice } from "@reduxjs/toolkit";
import {
  fetchingSchoolsReducerBuilder,
  fetchingSchoolReducerBuilder,
  editingSchoolReducerBuilder,
} from "./builders";

const initialState = {
  schools: [],
  schoolData: null,
  loading: false,
  choosenSchool: { name: "" },
  editSchoolPending: false,
};

export const schoolSlice = createSlice({
  name: "school",
  initialState,
  reducers: {
    setChoosenSchool: (state, action) => {
      state.choosenSchool = action.payload;
    },
  },
  extraReducers: (builder) => {
    fetchingSchoolsReducerBuilder(builder);
    fetchingSchoolReducerBuilder(builder);
    editingSchoolReducerBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const { setChoosenSchool } = schoolSlice.actions;

export const selectSchools = (state) => state.school.schools;
export const selectChoosenSchool = (state) => state.school.choosenSchool;
export const selectedSchool = (state) => state.school.schoolData;
export const selectEditSchoolPending = (state) =>
  state.school.editSchoolPending;

export default schoolSlice.reducer;
